import NextHead from "../components/Seo/NextHead";
import Link from "next/link";
import Layout from "../components/Layout";
import { DataSantai } from "../data/DataSantai";
import { asuransiIsiRumahMeta } from "../data/DataMetatags";
import { defBreadcrumb } from "../data/DataBreadcrumb";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { SantaiBreadcrumb } from "../data/DataBreadcrumb";
import { ImageComponent } from "../components/UserInterface/ImageComponent";
import santaiLogo from "../../public/static/images/png/santai-logo.png";
import santaiMalacca from "../../public/static/images/svg/SANTAI_MTWI.svg";
import santaiMSIG from "../../public/static/images/svg/SANTAI_MSIG.svg";
import santaiZURICH from "../../public/static/images/svg/SANTAI_ZURICH.svg";

import Description from "../components/UserInterface/Description";
import {
  StepsComponent,
} from "../components/UserInterface/StepsComponent";
import { SantaiSEO } from "../data/DataSEO";


const AsuransiIsiRumah = (props) => {
  const {
    breadcrumb,
    title,
    description,
    path,
    DataSantai,
    SantaiBreadcrumb,
  } = props;
  const { howTo } = DataSantai;

  return (
    <Layout>
      <NextHead
        title={title}
        description={description}
        url={path}
        breadcrumb={breadcrumb}
      />
      <BreadcrumbComponent items={SantaiBreadcrumb} />
      <ImageComponent url={santaiLogo} imgWidth='178px' />
      <Description
        marginMobile='15px 16px'
        font="Roboto"
        width="730px"
        text="Santai adalah produk proteksi yang melindungi segala bentuk perabotan dan peralatan rumah tangga serta isi rumah lainnya (tidak termasuk barang antik, perhiasan, emas, uang, surat berharga, binatang, dan tumbuhan) dari risiko - risiko yang terjadi. Alamat tempat tinggal yang dilindungi adalah alamat tempat tinggal yang tercantum pada Ringkasan Program Perlindungan."
      />
      <StepsComponent
        img={howTo.img}
        title={howTo.title}
        subtitle={howTo.subtitle}
        steps={howTo.steps}
      />

      <div className='type-component-wrapper'>
        <h2>Informasi Klaim</h2>
        <div className='container-section'>

          <Link
            href="asuransi-isi-rumah/Malacca"
            as="asuransi-isi-rumah/Malacca"
            legacyBehavior>
            <div className='content-section'>
              <ImageComponent url={santaiMalacca} imgWidth='202px' marginContainer='16px 16px 10px 16px' />
              <Description
                font="Roboto"
                width="304px"
                margin='0px 0px 15px 0px'
                fontSize='13px'
                text='Perlindungan Isi Rumah dari Risiko Tak Terduga dengan Jasa Penyedia Proteksimu PT Malacca Trust Wuwungan Insurance'
              />
              <div className='container-button'>
                <button className='content-button'>Selengkapnya</button>
              </div>
            </div>
          </Link>

          <Link
            href="asuransi-isi-rumah/MSIG"
            as="asuransi-isi-rumah/MSIG"
            legacyBehavior>
            <div className='content-section'>
              <ImageComponent url={santaiMSIG} imgWidth='202px' marginContainer='16px 16px 10px 16px' />
              <Description
                font="Roboto"
                width="304px"
                margin='0px 0px 15px 0px'
                fontSize='13px'
                text='Perlindungan Isi Rumah dari Risiko Tak Terduga dengan Jasa Penyedia Proteksimu PT Asuransi MSIG Indonesia (MSIG)'
              />
              <div className='container-button'>
                <button className='content-button'>Selengkapnya</button>
              </div>
            </div>
          </Link>

          <Link
            href="asuransi-isi-rumah/ZURICH"
            as="asuransi-isi-rumah/ZURICH"
            legacyBehavior>
            <div className='content-section'>
              <ImageComponent url={santaiZURICH} imgWidth='202px' marginContainer='16px 16px 10px 16px' />
              <Description
                font="Roboto"
                width="304px"
                margin='0px 0px 15px 0px'
                fontSize='13px'
                text='Perlindungan Isi Rumah dari Risiko Tak Terduga dengan Jasa Penyedia Proteksimu PT Zurich Asuransi Indonesia, Tbk'
              />
              <div className='container-button'>
                <button className='content-button'>Selengkapnya</button>
              </div>
            </div>
          </Link>

        </div>
      </div>

      <style jsx>{`
      .type-component-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 20px 0px 50px 0px;
      }
      .container-section{
        max-width: 1040px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        
      }
      .content-section{
        cursor: pointer;
        border-radius: 5px;
        box-shadow: 0px 2px 4px rgba(26, 26, 26, 0.2);
      }
      .container-button{
        display:flex;
        justify-content:center;
      }
      .content-button{
        width: 304px;
        margin: 0px 16px 16px 16px;
        background-color: var(--color-white);
        color: var(--color-red);
        padding: 10px;
        border: 2px solid;
        border-color: var(--color-red)
        border-radius: 8px;
        font-weight: bold;
        cursor: pointer;
      }
       @media only screen and (max-width: 950px) {
        .container-section {
          flex-direction: column;
        }
        .content-section{
          margin: 0px 16px 26px 16px;
        }
      }
      `}</style>
    </Layout>
  );
};

export const getStaticProps = async () => {
  const { title, description, path } = asuransiIsiRumahMeta;

  const breadcrumb = [
    ...defBreadcrumb,
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": process.env.baseUrl + path,
        name: title
      }
    }
  ];

  return {
    props: {
      breadcrumb,
      title,
      description,
      path,
      DataSantai,
      SantaiBreadcrumb,
      SantaiSEO
    }
  };
};

export default AsuransiIsiRumah;
